import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AlertInfo } from '../../../../../models/alert-info';
import { SavedDataInfo } from '../../../../../models/form/saved-data-info';
import { AlertNotificationService } from '../../../../../services/alert-notification.service';
import { RegulationsService } from '../../../../../services/api/general-settings/regulations.service';
import { FormService } from '../../../../../services/form.service';
import { ValidatorService } from '../../../../../services/validator.service';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { InputFieldComponent } from '../../../../../components/form/input-field/input-field.component';
import { SelectFieldComponent } from '../../../../../components/form/select-field/select-field.component';
import { TextAreaFieldComponent } from '../../../../../components/form/textarea-field/textarea-field.component';


@Component({
  selector: 'regulations-form',
  imports: [NgbAlert, InputFieldComponent, SelectFieldComponent, TextAreaFieldComponent, ReactiveFormsModule],
  templateUrl: './regulations-form.component.html',
  styleUrl: './regulations-form.component.scss'
})
export class RegulationsFormComponent {
  @Input() regulation?: any;
  @Input() readonlyRegulationsForm: boolean = false;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();

  form!: FormGroup;

  alertInfo: AlertInfo = { show: false, type: '', message: '' };
  lawsOptions: { key: string; value: string }[] = [];
  jurisdictionsOptions: { key: number; value: string }[] = [];
  allLaws: any[] = [];
  
  constructor(
    private validatorService: ValidatorService,
    private formService: FormService,
    private alertNotificationService: AlertNotificationService,
    private regulationsService: RegulationsService
  ) {
    this.regulationsService.jurisdictions$.subscribe((jurisdictions: any) => {
      this.jurisdictionsOptions = jurisdictions.map((jurisdiction: any) => ({ key: jurisdiction.jurisdictionId, value: jurisdiction.name }));
    })
    this.regulationsService.laws$.subscribe((laws: any) => {
      this.allLaws = laws; 
      const selectedJurisdiction = this.form?.get('jurisdiction')?.value;
      if (selectedJurisdiction) {
        this.filterLawsByJurisdiction(selectedJurisdiction);
      } else {
        this.lawsOptions = laws.map((law: any) => ({ key: law.lawId, value: law.name }));
      }
    });
  }


  ngOnInit(): void {
    this.form = new FormGroup({
      jurisdiction: new FormControl('', [Validators.required]),
      law: new FormControl('', [Validators.required]),
      title: new FormControl('', [Validators.required]),
      details: new FormControl('', [Validators.required]),
    });

    this.form.get('jurisdiction')?.valueChanges.subscribe(value => {
      if (value) {
        this.filterLawsByJurisdiction(value);
      }
    });
  }
  ngOnChanges(changes: SimpleChanges) {    
    if (changes['regulation'] && changes['regulation'].currentValue) {
      this.form.get('jurisdiction')?.setValue(this.regulation.jurisdiction.jurisdictionId);
      
      setTimeout(() => {
        this.form.patchValue({
          law: this.regulation.law.lawId,
          title: this.regulation.title,
          details: this.regulation.details,
        });
      }, 0);
    }
  }

  /**
     * *******************
     * Submit form methods
     * *******************
     */  
    showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.form);
    this.formService.setValidationErrors(this.form, validationErrors);
  }
  submitFormSuccess(response: any) {
    this.alertNotificationService.success('Operation completed successfully')
    this.showAlertInfo('success', 'Operation completed successfully');

    this.onSavedData.emit({
      success: true,
      response
    });
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  submitForm(): void {
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });

    if (this.form.valid) {

      const values = Object.assign(
        this.form.value,
        {
          tenantId: 1,
        },
      )

      this.alertInfo.show = false;
      this.formService.resetErrors(this.form);

      const serviceMethod = this.regulation ? this.regulationsService.update(this.regulation.id, values) : this.regulationsService.create(values);
      serviceMethod.subscribe({
        next: (response: any) => {
          this.submitFormSuccess(response)
        },
        error: (error: any) => {
          this.submitFormError(error)
        }
      })
    }
  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */

  getRegulationJurisdictionsSelect(): FormControl { return this.getFormControl('jurisdiction'); }
  getRegulationLawsSelect(): FormControl { return this.getFormControl('law'); }
  getRegulationTitleInput(): FormControl { return this.getFormControl('title'); }
  getRegulationDesrciptionInput(): FormControl { return this.getFormControl('details'); }

  getFormControl(name: string): FormControl { return this.form.get(name) as FormControl; }


  filterLawsByJurisdiction(jurisdictionId: number): void {    
    if (!this.allLaws || this.allLaws.length === 0) return;   

    const filteredLaws = this.allLaws.filter(law =>  law.jurisdiction.jurisdictionId == jurisdictionId
    );
    
    console.log('Filtered laws by jurisdiction', jurisdictionId, filteredLaws);
    
    this.lawsOptions = filteredLaws.map(law => ({ 
      key: law.lawId, 
      value: law.name 
    }));
  }
}
